import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { toVw, toVwMobile, toVwTablet } from '../utils/styles';
import { CONTAINER_WIDTH, CONTAINER_WIDTH_MD, CONTAINER_WIDTH_SM } from '../constants';
import mq from '@/utils/media-queries';

const Styled = styled.div`
  width: ${toVw(CONTAINER_WIDTH)};
  margin-right: auto;
  margin-left: auto;

  ${mq.tablet(css`
    width: ${toVwTablet(CONTAINER_WIDTH_MD)};
  `)};

  ${mq.mobile(css`
    width: ${toVwMobile(CONTAINER_WIDTH_SM)};
  `)};
`;

class Container extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    containerRef: PropTypes.func,
  };

  render() {
    const { children, className, containerRef, ...rest } = this.props;

    return (
      <Styled className={className} innerRef={containerRef} {...rest}>
        {children}
      </Styled>
    );
  }
}

export default Container;



// WEBPACK FOOTER //
// ./src/components/Container.js